export default "__VITE_ASSET__fc458c84__"